import { render, staticRenderFns } from "./auditSetting_number.vue?vue&type=template&id=77531df3&scoped=true"
import script from "./auditSetting_number.vue?vue&type=script&lang=ts"
export * from "./auditSetting_number.vue?vue&type=script&lang=ts"
import style0 from "./auditSetting_number.vue?vue&type=style&index=0&id=77531df3&prod&lang=less"
import style1 from "./auditSetting_number.vue?vue&type=style&index=1&id=77531df3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77531df3",
  null
  
)

export default component.exports